import { HStack, Text } from '@chakra-ui/react'
import { memo, ReactNode, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { StackedAvatars } from '@/components/molecules/Avatar/StackedAvatars'
import { useColorModeValue } from '@/components/ui/color-mode'

export const UserStackedAvatars = memo(
  ({
    users,
    totalCount,
    otherLabel,
  }: {
    users?: {
      id?: string
      fullname: string
      roles: string[]
      avatar?: { contentUrl?: string | undefined }
    }[]
    totalCount?: number
    otherLabel?: ReactNode
  }) => {
    const { t } = useTranslation()

    const avatars = useMemo(
      () =>
        users
          ?.map((user) => {
            return {
              id: user.id,
              name: user.fullname,
              url: user.avatar?.contentUrl,
              color:
                user.roles.includes('ROLE_ADMIN') ||
                user.roles.includes('ROLE_MODERATOR')
                  ? 'brand.400'
                  : undefined,
            }
          })
          .filter(Boolean) || [],
      [users]
    )

    const otherCount = useMemo(
      () => (totalCount == null ? 0 : Math.max(0, totalCount - avatars.length)),
      [totalCount, avatars.length]
    )

    const color = useColorModeValue('gray.500', 'gray.300')

    return (
      <HStack gap={2}>
        <StackedAvatars avatars={avatars} />
        {otherCount > 0 && (
          <Text color={color}>
            {otherLabel ||
              t('users.avatarStacked.andXOthers', {
                count: otherCount,
              })}
          </Text>
        )}
      </HStack>
    )
  }
)
